// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../../shared/reducers/busy-counter';
import claim from './jdp-claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import customer from './customer';
import customerResolutions from './customer-resolutions';
import formValidation from './form-validation';
import isActionButtonDisabled from './is-action-button-disabled';
import isEditable from './is-editable';
import isStickyHeaderVisible from './is-sticky-header-visible';
import isValidClaim from './is-valid-claim';
import product from './product-details';
import reasonsForReturn from './reasons-for-return';
import temporaryObjectKey from './temporary-object-key';
import warrantyStatusModal from './warranty-status-modal';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    customer,
    customerResolutions,
    formValidation,
    isActionButtonDisabled,
    isEditable,
    isStickyHeaderVisible,
    isValidClaim,
    product,
    reasonsForReturn,
    temporaryObjectKey,
    warrantyStatusModal
});



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/reducers/index.js